import React, { Component } from 'react'

export default class Component2 extends Component {
  render() {
    return (
      <div>I'm 22100095 Minje KIm</div>
    )
  }
}
